import React, { useEffect, useState } from 'react'
import { Dropdown, Menu, Spin } from 'antd'
import { useFeatureIsOn, useFeatureValue } from '@growthbook/growthbook-react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { CommentOutlined } from '@ant-design/icons'
import control from 'modules/control'
import PivotTableUX from 'components/PivotTable/PivotTableUX'
import PivotTableRenderers from 'components/PivotTable/Renderers/Base/Tree'

import PlaneTableUX from 'components/PivotTable/PlaneTableUX'
import PlaneTableRenderers from 'components/PivotTable/Renderers/Base/Plane'

import './ProjectionControlTable.scss'
import '../../../../../../../../components/PivotTable/pivottable.css'
import { GENERAL } from 'modules/core/constants'
import { useTranslation } from 'react-i18next'
import { getHashTable, setFormatNumber } from 'modules/core/utils'
import login from 'modules/login'
import { RealDetailDrawer } from '../RealDetailDrawer'

const ProjectionControlTable = ({
  dataSource,
  fields,
  isTableLoading,
  settings,
  setSettings,
  hasComment,
  setViewComment,
  setHasComment,
  setHash,
  setShowTableqp,
  loggedUser,
  conceptId,
  periodId,
  currencyId,
}) => {
  // const [settings, setSettings] = useState({})
  const [detailCellFilters, setDetailCellFilters] = useState({})
  const enabledPlaneTable = useFeatureIsOn('feature-plane-table')
  const enableFormatNumber = useFeatureIsOn('enable-format-number')
  const formatBaseNumber = useFeatureValue('format-number-table', 'Suma (Decimales)')
  const { t } = useTranslation()

  useEffect(() => {
    setSettings((prevState) => ({ ...prevState, data: dataSource }))
  }, [dataSource])

  const renderDetailDrawer = () => (
    <RealDetailDrawer
      visible={!_.isEmpty(detailCellFilters)}
      onClose={() => setDetailCellFilters({})}
      cellFilters={detailCellFilters}
      conceptId={conceptId}
      periodId={periodId}
      currencyId={currencyId}
    />
  )

  if (enabledPlaneTable) {
    return (
      <>
        <Spin spinning={isTableLoading}>
          <Dropdown
            trigger={['contextMenu']}
            overlay={
              <Menu>
                {GENERAL.OPTION_COMMENT.map((el) => (
                  <Menu.Item
                    key={el.key}
                    icon={<CommentOutlined />}
                    onClick={() => {
                      setViewComment(true)
                      setHasComment({ type: 'table', data: !hasComment.table })
                    }}
                  >
                    {t(el.label)}
                  </Menu.Item>
                ))}
              </Menu>
            }
          >
            <div style={{ width: '100%' }} className="projection-control-table-drilldown">
              <PlaneTableUX
                renderers={Object.assign({}, PlaneTableRenderers)}
                data={dataSource}
                onChange={(s) => {
                  setHash(getHashTable(s))
                  setSettings(s)
                  setShowTableqp(true)
                }}
                numberFormat={(val) =>
                  enableFormatNumber ? setFormatNumber(loggedUser, val) : val
                }
                vals={settings.default_value ? [settings.default_value] : ['amount']}
                cols={fields.columns}
                rows={fields.rows_default}
                aggregatorName={settings.default_format || formatBaseNumber}
                hiddenFromDragDrop={fields.values}
                hiddenFromAggregators={
                  dataSource[0] && dataSource[0].filter((el) => !fields.values.includes(el))
                }
                tableOptions={{
                  realMonths: fields?.real_months,
                  clickCallback: (info, value, record, pivotData, vals) => {
                    if (info.target.classList.contains('pvtVal')) {
                      setDetailCellFilters(record)
                    }
                  },
                }}
                plotlyConfig={{
                  responsive: true,
                }}
                tableFilter={{}}
                {...settings}
              />
            </div>
          </Dropdown>
        </Spin>
        {renderDetailDrawer()}
      </>
    )
  }

  return (
    <>
      <Spin spinning={isTableLoading}>
        <Dropdown
          trigger={['contextMenu']}
          overlay={
            <Menu>
              {GENERAL.OPTION_COMMENT.map((el) => (
                <Menu.Item
                  key={el.key}
                  icon={<CommentOutlined />}
                  onClick={() => {
                    setViewComment(true)
                    setHasComment({ type: 'table', data: !hasComment.table })
                  }}
                >
                  {t(el.label)}
                </Menu.Item>
              ))}
            </Menu>
          }
        >
          <div style={{ width: '100%' }} className="projection-control-table-drilldown">
            <PivotTableUX
              renderers={Object.assign({}, PivotTableRenderers)}
              data={dataSource}
              onChange={(s) => {
                setSettings(s)
                setShowTableqp(true)
                setHash(getHashTable(s))
              }}
              numberFormat={(val) => (enableFormatNumber ? setFormatNumber(loggedUser, val) : val)}
              vals={settings.default_value ? [settings.default_value] : ['amount']}
              cols={fields.columns}
              rows={fields.rows_default}
              aggregatorName={settings.default_format || formatBaseNumber}
              hiddenFromDragDrop={fields.values}
              hiddenFromAggregators={
                dataSource[0] && dataSource[0].filter((el) => !fields.values.includes(el))
              }
              tableOptions={{
                realMonths: fields?.real_months,
                clickCallback: (info, value, record, pivotData, vals) => {
                  if (info.target.classList.contains('pvtVal')) {
                    setDetailCellFilters(record)
                  }
                },
              }}
              plotlyConfig={{
                responsive: true,
              }}
              tableFilter={{}}
              {...settings}
            />
          </div>
        </Dropdown>
      </Spin>
      {renderDetailDrawer()}
    </>
  )
}

const mapStateToProps = (state) => ({
  loggedUser: login.selectors.getWhoAmI(state),
})

const mapDispatchToProps = {
  fetchOpenRow: control.actions.fetchOpenRow,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectionControlTable)
